/* eslint-disable react/display-name */
import React from 'react'
import NewCopyIcon from '../../../components/icons/newCopy'
import { copyToClipboard } from '../../../utils/copyToClipboard'

import './new-code-blocks-wrapper.css'

export default ({ children }: any) => {
  const fptiData = typeof window !== `undefined` && window.fpti
  const gaData = typeof window !== `undefined` && window.ga

  const handleCopyClipboard = () => {
    copyToClipboard(children.props.children)

    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: 'copy-content',
          component: 'devdiscoverynodeweb',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    if (gaData) {
      gaData('send', 'event', {
        eventCategory: 'codeblock',
        eventAction: 'click',
        eventLabel: 'copyContent',
      })
    }
  }

  return (
    <div className="new-codeBlocks-wrapper">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginBottom: '22px',
        }}
      >
        <div onClick={() => handleCopyClipboard()}>
          <NewCopyIcon />
        </div>
      </div>
      {children}
    </div>
  )
}
